<app-filter-view [dropdownListBO]="dropdownListBO" [dropdownListOrderCluster]="dropdownListOrderCluster"
    [dropdownListCustomer]="dropdownListCustomer" [dropdownListCountry]="dropdownListCountry"
    [dropdownListMonth]="dropdownListMonth" [dropdownListYear]="dropdownListYear"
    [dropdownListOrderType]="dropdownListOrderType" [orderTypeOfOrderCLuster]="orderTypeOfOrderCLuster"
    [customerOfCountry]="customerOfCountry" [selectedItemsBO]="selectedItemsBO"
    [selectedItemsOrderCluster]="selectedItemsOrderCluster" [selectedItemsCustomer]="selectedItemsCustomer"
    [selectedItemsCountry]="selectedItemsCountry" [selectedItemsMonth]="selectedItemsMonth"
    [selectedItemsYear]="selectedItemsYear" [selectedItemsOrderType]="selectedItemsOrderType"
    [idLeadGlobalOfCustomerName]="idLeadGlobalOfCustomerName" [selectedItemsIdGlobal]="selectedItemsIdGlobal"
    [dropdownListOrderStatus]="dropdownListOrderStatus" [dropdownListLead]="dropdownListLead"
    [selectedItemsOrderStatus]="selectedItemsOrderStatus" [selectedItemsLead]="selectedItemsLead"
    [viewOrderStatus]="viewOrderStatus" [viewMonth]="viewMonth" [overviewOrderdDetailReportSpan]="true"
    [slaKpiSpan]="false" [completedDetailSpan]="false"
    (sendFilterEvent)="loadReport($event)"
    (updateFilterEvent)="updateFilterEvent($event)">
</app-filter-view>

<div class="d-flex justify-content-start mt-4" *ngIf="viexExportCsv()">
    <button class="btn btn-primary btn-lg active btn-sm reset-style" (click)="initializeTendine()">RESET
       ALL FILTERS</button>


    <button class="btn btn-primary btn-lg active btn-sm logout-style" (click)="exportAllItemsCsv()">EXPORT CSV</button>
</div>

<div class="d-flex justify-content-center" style="margin-top:4%;">
    <ng2-smart-table [settings]="settingsFilter" [source]="listOrder">
    </ng2-smart-table>
</div>

<div class="d-flex justify-content-center style-more-orders" *ngIf="viewLoadMoreReport()">
    <div (click)="loadReportSelected()" style="cursor: pointer;">
        <div class="d-flex align-items-center">
            <i class="fa-solid fa-arrows-rotate"></i>
            <span>Load more orders</span>
        </div>
    </div>